// extracted by mini-css-extract-plugin
export var container = "_8w-0";
export var containerTopRight = "_8w-1";